/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Total_ExposureInputs */

const en_total_exposure = /** @type {(inputs: Total_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Exposure`)
};

const es_total_exposure = /** @type {(inputs: Total_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exposición total`)
};

const fr_total_exposure = /** @type {(inputs: Total_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exposition totale`)
};

const de_total_exposure = /** @type {(inputs: Total_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamte Reichweite`)
};

const ja_total_exposure = /** @type {(inputs: Total_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`総インプレッション`)
};

const zh_total_exposure = /** @type {(inputs: Total_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总曝光量`)
};

const ar_total_exposure = /** @type {(inputs: Total_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجمالي الظهور`)
};

const id_total_exposure = /** @type {(inputs: Total_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Eksposur`)
};

const it_total_exposure = /** @type {(inputs: Total_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esposizione Totale`)
};

const ru_total_exposure = /** @type {(inputs: Total_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общий охват`)
};

const pt_total_exposure = /** @type {(inputs: Total_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exposição Total`)
};

const ko_total_exposure = /** @type {(inputs: Total_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`총 노출 수`)
};

/**
* | output |
* | --- |
* | "Total Exposure" |
*
* @param {Total_ExposureInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const total_exposure = /** @type {((inputs?: Total_ExposureInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Total_ExposureInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_total_exposure(inputs)
	if (locale === "es") return es_total_exposure(inputs)
	if (locale === "fr") return fr_total_exposure(inputs)
	if (locale === "de") return de_total_exposure(inputs)
	if (locale === "ja") return ja_total_exposure(inputs)
	if (locale === "zh") return zh_total_exposure(inputs)
	if (locale === "ar") return ar_total_exposure(inputs)
	if (locale === "id") return id_total_exposure(inputs)
	if (locale === "it") return it_total_exposure(inputs)
	if (locale === "ru") return ru_total_exposure(inputs)
	if (locale === "pt") return pt_total_exposure(inputs)
	return ko_total_exposure(inputs)
});